import { ModalService } from '@app/plugins/iview-modal-modify/service';
import { DataBaseService } from '@db/services/DataBaseService';
import CreateEditForm from '@db/components/db/db-modal-create-edit-form';
import i18n from '@app/plugins/i18n';

class DataBaseModalService extends ModalService {
  constructor() {
    super(DataBaseService);
  }

  remove(id, item) {
    return this.$removeItem(id, item, {
      content: i18n.t('db.database.modal.remove.content', {
        name: `<strong>${item.name}</strong>`
      })
    });
  }

  edit(id, item) {
    return this.$open({
      title: i18n.t('shared.component.modal.edit'),
      width: this.size.confirm,
      render: h =>
        h(CreateEditForm, {
          props: {
            id: id,
            item: item
          },

          on: {
            success: data => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }

  create() {
    return this.$open({
      title: i18n.t('shared.component.modal.create'),
      width: this.size.confirm,
      render: h =>
        h(CreateEditForm, {
          on: {
            success: data => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }
}

const instance = new DataBaseModalService();
export { instance as DataBaseModalService };
